import React, { useState } from "react";
import "./pstyle.css";
import { MDBContainer, MDBInput } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import GlobalURL from "../baseUrl";
import Button from "react-bootstrap/Button";

import { useSelector } from "react-redux";
import translations from "../locals/translation";

function ResetPassword() {
  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };
  const navigate = useNavigate();
  const [newPass, setNewPass] = useState("");
  const [cpass, setCpass] = useState("");

  const [message, setMessage] = useState("");
  const [showMes, setShowMes] = useState(false);
  const [loading, setLoading] = useState(false);

  // function isStrongPassword(password) {
  //     // Minimum length of 8 characters
  //     const minLength = 8;

  //     // Regular expressions to check for various criteria
  //     const hasUpperCase = /[A-Z]/.test(password);
  //     const hasLowerCase = /[a-z]/.test(password);
  //     const hasDigit = /\d/.test(password);
  //     const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

  //     // Check all criteria
  //     const isStrong =
  //         hasUpperCase &&
  //         hasLowerCase &&
  //         hasDigit &&
  //         hasSpecialChar &&
  //         password.length >= minLength;

  //     return isStrong;
  // }

  //Your password must meet the following criteria:
  // Minimum length of 8 characters.
  // At least one uppercase letter (A-Z).
  // At least one lowercase letter (a-z).
  // At least one digit (0-9).
  // At least one special character (!@#$%^&*()_+{}[]:;<>,.?~\/-).

  const subMitPass = async () => {
    setLoading(true);

    if (cpass !== newPass) {
      setShowMes(true);
      setLoading(false);
      setMessage(t("Password Not matching"));

      return;
    }

    const token = localStorage.getItem("token");
    setShowMes(false);
    setLoading(true);
    try {
      const apiUrl = `${GlobalURL}/api/dev/admin/auth/resetPassword`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          lang_id: language,
        },
        body: JSON.stringify({
          token: token,
          password: newPass,
        }),
      });
      const res = await response.json();

      if (res.status_code === 400) {
        setMessage(res.message);
        setShowMes(true);
        setLoading(false);
        return;
      }
      if (res.status_code === 200) {
        setLoading(false);
        navigate("/");
      }
    } catch (error) {
      setMessage(error.message);
      setShowMes(true);
      setLoading(false);
      console.error("Error logging in:", error.message);
    }
  };
  return (
    <React.Fragment>
      {/* <Header /> */}
      <div className="body-container">
        <div className="login-form-outer">
          <div className="logo-in-login">
            <img src="./img/sideLogo.png" alt="logo" />
          </div>
          <MDBContainer
            className="p-6 my-0 d-flex flex-column w-25"
            id="border-login-form2"
          >
            <div className="login-heading">
              <h1 style={{ fontFamily: "cooper", color: "#431118" }}>
                {t("Reset Password")}
              </h1>
            </div>
            <div className="message-on-login">
              <p>{showMes && message}</p>
            </div>
            <div className="login-form-headings">
              <p>{t("New Password")}</p>
            </div>
            <MDBInput
              wrapperClass="mb-4"
              placeholder={t("New Password")}
              id="form2"
              type="password"
              value={newPass}
              onChange={(e) => {
                setNewPass(e.target.value);
              }}
            />
            <div className="login-form-headings">
              <p>{t("Confirm New Password")}</p>
            </div>
            <MDBInput
              wrapperClass="mb-4"
              placeholder={t("Confirm New Password")}
              id="form2"
              type="text"
              value={cpass}
              onChange={(e) => {
                setCpass(e.target.value);
              }}
            />
            <div className="d-flex justify-content-between mx-3 mb-4"></div>
            <Button
              variant="success"
              className="buttons"
              style={{ background: "rgba(67, 17, 23, 1)", outline: "none" }}
              onClick={() => {
                subMitPass();
              }}
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="loading-spinner"></div>{" "}
                  <p className="logging-heading">{t("setting")}</p>
                </div>
              ) : (
                t("Set New Password")
              )}
            </Button>{" "}
          </MDBContainer>
        </div>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  );
}

export default ResetPassword;
